import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Kick off the service worker registration after the first paint. The SW
// powers "Add to Home Screen" and receives Web Push notifications.
if ("requestIdleCallback" in window) {
  window.requestIdleCallback(() => registerServiceWorker());
} else {
  window.addEventListener("load", () => registerServiceWorker());
}
